import PropTypes from 'prop-types'

import './Tags.scss'

export const Tags = ({ labels = [] }) => {
  return (
    <>
      {labels && (
        <ul className="sc-pr-tags">
          {labels.map((label, index) => (
            <li key={`tag-${index}`}>{label}</li>
          ))}
        </ul>
      )}
    </>
  )
}

Tags.propTypes = {
  labels: PropTypes.array,
  locale: PropTypes.string.isRequired,
}

export default Tags
